import { ref, type Ref } from 'vue'
import { defineStore } from 'pinia'
import type { ContainerType, WasteType } from '@/models/ContainerType'
import { computed } from '@vue/reactivity'

export const useContainerTypeStore = defineStore(
  'container_types',
  () => {
    const containerTypes: Ref<ContainerType[]> = ref([])
    const getData = () => containerTypes.value
    const setData = (data: ContainerType[]) => (containerTypes.value = data)

    const wasteTypes = computed(() => {
      return containerTypes.value.reduce<WasteType[]>((wasteTypes, containerType) => {
        const wasteType = wasteTypes.find(
          (wasteType) => wasteType.uuid === containerType.wasteTypeUuid,
        )

        if (wasteType) {
          wasteType.volumes.push(containerType.volume)
        } else {
          wasteTypes.push({
            name: containerType.wasteTypeName,
            uuid: containerType.wasteTypeUuid,
            volumes: [containerType.volume],
          })
        }

        return wasteTypes
      }, [])
    })

    const findByUuid = (uuid: string) => {
      return containerTypes.value.find((type) => type.uuid === uuid) || null
    }

    const findByWasteTypeAndVolume = (wasteType: WasteType, volume: number) => {
      return (
        containerTypes.value.find(
          (containerType) =>
            containerType.wasteTypeUuid === wasteType.uuid && containerType.volume === volume,
        ) || null
      )
    }

    const getVolumes = (wasteType: WasteType | null) => {
      let volumes: number[] = []

      if (wasteType) {
        volumes = wasteType.volumes
      } else {
        wasteTypes.value.forEach((wasteType) => (volumes = volumes.concat(wasteType.volumes)))
        volumes = [...new Set(volumes)]
      }

      return volumes.sort((a, b) => a - b)
    }

    return {
      containerTypes,
      wasteTypes,
      getData,
      setData,
      findByUuid,
      findByWasteTypeAndVolume,
      getVolumes,
    }
  },
  {
    persist: true,
  },
)
